module.exports = __webpack_public_path__ + "static/media/gb-eng.797c586f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gb-eng.svg
// module id = 118
// module chunks = 0